import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-form-loading-spinner',
  templateUrl: './form-loading-spinner.component.html',
  styleUrls: ['./form-loading-spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class FormLoadingSpinnerComponent {}
